import { createUserMessage } from '@/ai/utils/promptUtils'

export const chatLogType = {
  USER_PROMPT: 'user-prompt',
  AI_TEXT_RESPONSE: 'ai-text-response',
  AI_FUNCTION_CALL: 'ai-function-call'
}

export const constructMessagesHistory = (messages) => {
  const outputs = []

  for (const message of messages) {
    switch (message.type) {
      case chatLogType.USER_PROMPT:
        outputs.push(createUserMessage(message.content))
        break
      case chatLogType.AI_TEXT_RESPONSE:
        if (!message.aiOutput) {
          continue
        }

        const output = JSON.parse(message.aiOutput).find((item) => item.type === 'message')
        outputs.push(output)
        break
      case chatLogType.AI_FUNCTION_CALL:
        if (!message.aiOutput) {
          continue
        }

        const functionCallOutput = JSON.parse(message.aiOutput)

        for (const item of functionCallOutput) {
          if (item.type === 'function_call') {
            outputs.push(item)
            outputs.push({
              type: 'function_call_output',
              call_id: item.call_id,
              output: JSON.stringify({ success: true })
            })
          }
        }
        break
    }
  }

  return outputs
}
